import { createContext, useContext } from "react";

export interface HeaderSlots {
  titleSlot: HTMLElement | null;
  actionsSlot: HTMLElement | null;
  setTitleSlot: (el: HTMLElement | null) => void;
  setActionsSlot: (el: HTMLElement | null) => void;
  registered: number;
  setRegistered: (fn: (n: number) => number) => void;
}

export const HeaderSlotsContext = createContext<HeaderSlots | null>(null);

export const useHeaderSlots = () => {
  const ctx = useContext(HeaderSlotsContext);
  if (!ctx) throw new Error("useHeaderSlots must be used inside HeaderSlotsProvider");
  return ctx;
};
